module.exports = __webpack_public_path__ + "static/media/national-2-web-light.f07e0a13.woff";